import { AgrProcessEnv, setAgrEnvironment } from '@next/core-lib/environment';

import { Environment } from './environments/environment.model';

export { Environment } from './environments/environment.model';

const withRequiredKubeFallbacks = (env: AgrProcessEnv): AgrProcessEnv => {
  if (!env.APP_INSIGHTS_KEY) {
    return env;
  }

  const applicationKey = env.APPLICATION_KEY || 'pig-site';

  return {
    ...env,
    KUBE_POD_NAME: env.KUBE_POD_NAME || `${applicationKey.toLowerCase()}-local-0`,
    KUBE_NODE_NAME: env.KUBE_NODE_NAME || 'local-node',
    KUBE_TEAM: env.KUBE_TEAM || 'local',
  };
};

const isLocalBrowserHost = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  return ['localhost', '127.0.0.1'].includes(window.location.hostname);
};

const withLocalRedirectOverrides = (env: AgrProcessEnv): AgrProcessEnv => {
  if (!isLocalBrowserHost()) {
    return env;
  }

  const origin = window.location.origin;

  return {
    ...env,
    API_BASE_URL: '',
    APIM_BASE_URL: '/external',
    REDIRECT_URL: origin,
    NEDAP_REDIRECT_URI: `${origin}/third-parties/nedap/response`,
  };
};

export const setEnvironment = ({
  /* APP_SPECIFIC_ENV, */
  NEDAP_BASE_URL,
  NEDAP_CLIENT_ID,
  NEDAP_REDIRECT_URI,
  NEDAP_WORKSPACE_ID,
  NEDAP_REPORT_ID,
  ...env
}: AgrProcessEnv): Environment => {
  const normalizedEnvironment = withLocalRedirectOverrides(withRequiredKubeFallbacks(env));

  return {
    /* APP_SPECIFIC_ENV, */
    /* APP_SPECIFIC_ENV: ..., */
    ...setAgrEnvironment(normalizedEnvironment),
    NEDAP_BASE_URL,
    NEDAP_CLIENT_ID,
    NEDAP_REDIRECT_URI: normalizedEnvironment.NEDAP_REDIRECT_URI || NEDAP_REDIRECT_URI,
    NEDAP_WORKSPACE_ID,
    NEDAP_REPORT_ID,
  };
};

export const mergeEnvironment = (
  baseEnvironment: AgrProcessEnv,
  runtimeEnvironment: Record<string, string>,
): Environment =>
  setEnvironment({
    ...baseEnvironment,
    ...runtimeEnvironment,
  });
